export default __webpack_public_path__ + "static/media/project-ittisa.d6190c6f.png";